import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './SystemScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import * as SystemActions from '../../actions/SystemActions';
import FilterScreen from './FilterComponent/FilterComponent';
import TableScreen from './TableComponent/TableComponent';
import { Modal, Button, Spin, Table, Form, Select } from 'antd';
import { Grid } from '@material-ui/core';
import { employeeById } from 'app/reducers';
import TextInput from '../../../app/components/TextInput';
import { debounce } from 'debounce';
import ApiService from 'app/services/ApiService';

const SystemScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    const [visibleModal, setVisibleModal] = useState(false);
    const [idSystem, setIdSystem] = useState(undefined);
    const [systemName, setSystemName] = useState('');
    const [keyUser, setKeyUser] = useState('');
    const [functional, setFunctional] = useState('');
    const [description, setDescription] = useState('');
    const [subDirectionOrigin, setSubDirectionOrigin] = useState('');
    const [FiltroSistemas, setFiltroSistemas] = useState([]);
    const [FiltroKeyUser, setFiltroKeyUser] = useState([]);
    const [FiltroFuncional, setFiltroFuncional] = useState([]);
    const { confirm } = Modal;

    const [keySelected, setKeySelected] = useState([]);
    const [objOriginal, setObjOriginal] = useState({});

    const {
        listSystems,
        isSaveRecord,
        pagination,
        filter,
        isLoadingAllKeyUser,
        listAllKeyUser,
    } = useSelector(state => state.SystemReducer);

    //Filtro: Courses
    const optionAllKeyUser = listAllKeyUser.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Funcion para filtrar courses
    const handleSearchAllKeyUsers = (courses) => {
        //    if (email !== '') {
        dispatch(SystemActions.getAllKeyUsers());
        //  }
    }

    const setKU = (item) => {
        setKeySelected(item)
        bloqueo(item);
    }

    const submit = () => {
        var payload =
        {
            idSystem: idSystem,
            systemName: systemName,
            keyUser: [],//keySelected.length > 0 ? keySelected.join("|") : '',
            functional: functional,
            description: description,
            subDirection: subDirectionOrigin.toString()
        }

        keySelected.forEach(ex => {
            payload.keyUser.push({ EmployeeId: ex })
        })

        dispatch(SystemActions.insUpdSystem(payload, updateTable));
    }

    const updateTable = () => {
        dispatch(SystemActions.fetchSystems({
            subdirectionorigin: employeeData.idSubdirection,
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listName: FiltroSistemas.join(','),
            listKeyUser: FiltroKeyUser.join(','),
            listFunctional: FiltroFuncional.join(',')
        }));
        setVisibleModal(false);
        setObjOriginal({});
        setIdSystem(undefined);
        setSystemName('');
        setKeySelected([]);
        setFunctional('');
        setDescription('');
        dispatch(SystemActions.getNames(employeeData.idSubdirection));
        dispatch(SystemActions.getKeyUsers(employeeData.idSubdirection));
        dispatch(SystemActions.getFunctionals(employeeData.idSubdirection));
    }

    const showConfirmDelete = (data) => {
        confirm({
            title: '¿Eliminar Sistema?',
            content: data.systemName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {

                dispatch(SystemActions.deleteSystem(data, () => {
                    if (pagination.current !== 1 && listSystems.length === 1) {
                        pagination.current = pagination.current - 1;
                    }

                    setFiltroSistemas(FiltroSistemas.filter(x => x !== data.idSystem))
                    setFiltroKeyUser(FiltroKeyUser.filter(x => x !== data.keyUser))
                    setFiltroFuncional(FiltroFuncional.filter(x => x !== data.functional))
                    dispatch(SystemActions.clear());
                    dispatch(SystemActions.fetchSystems({
                        subdirectionorigin: employeeData.idSubdirection,
                        offset: (pagination.current - 1) * pagination.pageSize,
                        limit: pagination.pageSize,
                        sortColumn: pagination.column,
                        sortDir: pagination.order,
                        listName: FiltroSistemas.filter(x => x !== data.idSystem).join(','),
                        listKeyUser: FiltroKeyUser.filter(x => x !== data.keyUser).join(','),
                        listFunctional: FiltroFuncional.filter(x => x !== data.functional).join(',')
                    }));;
                    dispatch(SystemActions.getNames(employeeData.idSubdirection));
                    dispatch(SystemActions.getKeyUsers(employeeData.idSubdirection));
                    dispatch(SystemActions.getFunctionals(employeeData.idSubdirection));
                }))
            },
            onCancel() { },
        });

    }

    const newSystem = () => {
        setIdSystem(undefined);
        setSystemName('');
        setKeySelected([]);
        setFunctional('');
        setDescription('');
        setSubDirectionOrigin(employeeData.idSubdirection);
        setObjOriginal({});
        setVisibleModal(true);
    }

    const editSystem = async (record) => {
        dispatch(SystemActions.getAllKeyUsers());
        setIdSystem(record.idSystem);
        setSystemName(record.systemName);
        setFunctional(record.functional);
        setDescription(record.description);
        setSubDirectionOrigin(employeeData.idSubdirection);
        var lista = await ApiService.getEditKeyUserNames({
            idSubdirecion: employeeData.idSubdirection,
            idSystem: record.idSystem
        })
        var obj = [];
        for (var i = 0; i < lista.listData.length; i++) {
            obj.push(lista.listData[i].key)
        }
        setKeySelected(obj)
        bloqueo(obj);
        setObjOriginal({
            idSystem_: record.idSystem,
            systemName_: record.systemName,
            functional_: record.functional,
            description_: record.description,
            keys: obj,
        })

        setVisibleModal(true);
    }

    useEffect(() => {
        dispatch(SystemActions.clear());
        dispatch(SystemActions.fetchSystems({
            subdirectionorigin: employeeData.idSubdirection,
            offset: 0,
            limit: 25
        }))
        dispatch(SystemActions.getNames(employeeData.idSubdirection));
        dispatch(SystemActions.getKeyUsers(employeeData.idSubdirection));
        dispatch(SystemActions.getFunctionals(employeeData.idSubdirection));
    }, [dispatch]);

    const size = (text, size, property = "") => {
        var tsize = text.length;
        var ret = ` ${tsize}/${size}`;
        if (property != "") {
            var obj = tableInfo.find(x => x.systemName.toLowerCase() === text.toLowerCase());
            if (obj != undefined) {
                if (idSystem === undefined) {
                    ret = "Ya esta asignado";
                } else {
                    if (idSystem != obj.idSystem) ret = "Ya esta asignado";
                }
            }
        }
        return ret;
    }

    const csize = (text, size, property = "") => {
        var tsize = text.length;
        var ret = tsize == size ? "red" : "grey"
        if (property != "") {
            var obj = tableInfo.find(x => x.systemName.toLowerCase() === text.toLowerCase());
            if (obj != undefined) {
                if (idSystem === undefined) {
                    ret = "red";
                } else {
                    if (idSystem != obj.idSystem) ret = "red";
                }
            }
        }
        return ret;
    }

    const [bloqueado, setBloqueado] = useState(true);

    const bloqueo = (e = []) => {

        setBloqueado(false);
            if (systemName == ''
            || e.length == 0
            || functional == ''
            || description == '') setBloqueado(true);
        

        var obj = tableInfo.find(x => x.systemName.toLowerCase() === systemName.toLowerCase());
        if (obj != undefined) {
            if (idSystem === undefined) setBloqueado(true);
            if (idSystem != obj.idSystem) setBloqueado(true);
            if (idSystem === obj.idSystem) {
                let { systemName_, functional_, description_, keys } = objOriginal;
                if (systemName_ == systemName
                    && functional_ == functional
                    && description_ == description
                    && e.length == keys.length) {
                    let arr1 = [...e].sort();
                    let arr2 = [...keys].sort();
                    let exist = true;

                    for (let i = 0; i < arr2.length; i++) {
                        if (arr2[i] != arr1[i]) {
                            exist = false;
                            break;
                        }
                    }
                    if (exist) setBloqueado(true);
                }
            }
        }
    }

    const tableInfo = listSystems.map(
        (record) => {
            return {
                'key': record.idSystem,
                'idSystem': record.idSystem,
                'systemName': record.systemName,
                'keyUser': record.keyUser,
                'functional': record.functional,
                'description': record.description
            }
        }
    );

    useEffect(() => {
        bloqueo(keySelected);
    }, [systemName, keyUser, functional, description]);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header=' Sistemas' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Bandeja de Sistemas"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <FilterScreen
                            newSystem={newSystem}
                            FiltroSistemas={FiltroSistemas} setFiltroSistemas={setFiltroSistemas}
                            FiltroKeyUser={FiltroKeyUser} setFiltroKeyUser={setFiltroKeyUser}
                            FiltroFuncional={FiltroFuncional} setFiltroFuncional={setFiltroFuncional}
                        />
                        <TableScreen
                            editSystem={editSystem}
                            showConfirmDelete={showConfirmDelete}
                            FiltroSistemas={FiltroSistemas} setFiltroSistemas={setFiltroSistemas}
                            FiltroKeyUser={FiltroKeyUser} setFiltroKeyUser={setFiltroKeyUser}
                            FiltroFuncional={FiltroFuncional} setFiltroFuncional={setFiltroFuncional}
                            dtsize={{ x: 'min-content', y: (height - 430) }}
                            //wHeight={window.innerHeight)}
                            size={"small"}
                        />
                        <Modal
                            destroyOnClose={true}
                            onCancel={() => setVisibleModal(false)}
                            visible={visibleModal}
                            title={<TextEvents
                                text={idSystem === undefined ? 'Nuevo Sistema' : ((siteId === "HUB" ? 'Editar' : 'Visualizar') + ' Sistema')}
                                color='cotemar'
                                size='label'
                                weight='bold'
                            />}
                            width={'650px'}
                            centered={true}
                            footer={[
                                <Button key="back" type="danger" ghost onClick={() => setVisibleModal(false)}>
                                    Cancelar
                                </Button>,
                                siteId === "HUB" ?
                                    <Button disabled={bloqueado} key="submit" type="primary" loading={false} onClick={() => submit()}>
                                        Confirmar
                                    </Button> : null,
                            ]}
                        >
                            <Spin spinning={isSaveRecord}>
                                <Grid container /*direction="row"*/>
                                    <Grid item xs={12}>
                                        <TextInput
                                            value={systemName}
                                            setValue={setSystemName}
                                            text='Nombre:'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            maxLength={50}
                                            tamano={size(systemName, 50, "systemName")}
                                            tcolor={csize(systemName, 50, "systemName")}
                                            mode='input'
                                            placeholder='Nombre del Sistema'
                                            disabled={siteId === "HUB" ? false : true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextEvents
                                            text='KeyUser(s):'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            value={keySelected}
                                            loading={isLoadingAllKeyUser}
                                            placeholder="[Selecione KeyUser]"
                                            showSearch
                                            onChange={setKU}
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            optionFilterProp="Children"
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            mode="multiple"
                                            onSearch={debounce(handleSearchAllKeyUsers, 500)}
                                        >
                                            {optionAllKeyUser}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextInput
                                            value={functional}
                                            setValue={setFunctional}
                                            text='Funcional:'
                                            color='darker'
                                            size='label'
                                            maxLength={50}
                                            tamano={size(functional, 50)}
                                            tcolor={csize(functional, 50)}
                                            weight='medium'
                                            mode='input'
                                            placeholder='Nombre del Funcional'
                                            disabled={siteId === "HUB" ? false : true}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextInput
                                            value={description}
                                            setValue={setDescription}
                                            text="Descripcion: "
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode='input'
                                            maxLength={100}
                                            placeholder='Descripción del sistema'
                                            tamano={size(description, 100)}
                                            tcolor={csize(description, 100)}
                                            disabled={siteId === "HUB" ? false : true}
                                        />
                                    </Grid>

                                </Grid>
                            </Spin>
                        </Modal>
                    </Paper>
                </div>
            </div>
        </div >
    )
}

export default SystemScreen;